// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1tmjr","name":"Header_name__1sPHP","birthday":"Header_birthday__SC1nA","skeleton":"Header_skeleton__w30Ji"};